<template>
  <div class="container-fluid">
    <mdb-container>
      <mdb-row>
        <mdb-card-title>
          <strong> Add or Remove Assets</strong>
        </mdb-card-title>
      </mdb-row>

      <mdb-row>
        <AssetsConfig />
      </mdb-row>
    </mdb-container>
  </div>
</template>

<script>
import AssetsConfig from "@/components/AssetsConfig";
import { mdbCardTitle, mdbRow, mdbContainer } from "mdbvue";

export default {
  name: "Assets",
  components: {
    AssetsConfig,
    mdbCardTitle,
    mdbRow,
    mdbContainer,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
